import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import MUIDataTable from "mui-datatables";

const useStyles = makeStyles((theme) =>
  createStyles({
    box: {
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(1),
      borderRight: "1px solid #dcdcdc",
    },
    tableHead: {
      height: 48,
      backgroundColor: "#fafafa",
    },
    tableRow: {
      height: 32,
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
    },
    tableRowNone: {
      height: 126,
    },
    tblHead: {
      textAlign: "center",
      fontSize: 12,
      fontWeight: 500,
    },
    tblHeadStatus: {
      textAlign: "center",
      fontSize: 12,
      fontWeight: 500,
    },
    tblHeadLeft: {
      textAlign: "left",
      fontSize: 12,
      fontWeight: 500,
    },
    tblDataCenter: {
      textAlign: "center",
    },
    tblDataLeft: {
      textAlign: "left",
    },
    customTitle: {
      fontSize: 16,
      color: "#000",
    },
  })
);

const ByAreaDetailTable = ({ data, selectedAreaLayerId }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const showPrefectureColumn = [
    "regular_1_l2",
    "regular_1_l3",
  ].includes(selectedAreaLayerId);

  const columns = [
    {
      name: "#",
      options: {
        filter: false,
        customBodyRender: (value) => {
          return <div className={classes.tblDataCenter}>{value}</div>;
        },
      },
    },
    {
      name: "エリア名",
      options: {
        filter: true,
        sort: true,
        customHeadLabelRender: (columnMeta) => (
          <span style={{ minWidth: 120 }} className={classes.tblHeadLeft}>
            エリア名
          </span>
        ),
        customBodyRender: (value) => {
          return (
            <div style={{ minWidth: "200px" }} className={classes.tblDataLeft}>
              {value}
            </div>
          );
        },
      },
    },
    ...(showPrefectureColumn
      ? [
          {
            name: "都道府県",
            options: {
              filter: true,
              sort: true,
              customHeadLabelRender: () => (
                <span className={classes.tblHeadStatus}>都道府県</span>
              ),
              customBodyRender: (value) => {
                return (
                  <div
                    style={{ minWidth: "120px" }}
                    className={classes.tblDataCenter}
                  >
                    {value}
                  </div>
                );
              },
            },
          },
        ]
      : []),
    {
      name: "登録数",
      options: {
        filter: false,
        sort: false,
        customHeadLabelRender: () => (
          <span className={classes.tblHeadStatus}>登録数</span>
        ),
        customBodyRender: (value) => {
          return <div className={classes.tblDataCenter}>{value}</div>;
        },
        // customBodyRender: (_, tableMeta) => {
        //   const rowIndex = tableMeta.rowIndex;
        //   const status = countdowns[rowIndex] || "計算中...";

        //   return (
        //     <div
        //       className={classes.tblDataCenter}
        //       style={{ minWidth: "100px" }}
        //       dangerouslySetInnerHTML={{ __html: status }}
        //     />
        //   );
        // },
        // filterOptions: {
        //   names: ["開催中", "終了"],
        //   logic(value, filterVal) {
        //     const derivedStatus = value === true ? "開催中" : "終了";
        //     return !filterVal.includes(derivedStatus);
        //   },
        // },
      },
    },
    {
      name: "未撮影数",
      options: {
        filter: false,
        sort: true,
        customHeadLabelRender: (columnMeta) => (
          <span className={classes.tblHead}>未撮影数</span>
        ),
        customBodyRender: (value) => {
          return <div className={classes.tblDataCenter}>{value}</div>;
        },
      },
    },
    {
      name: "レビューOK撮影数",
      options: {
        filter: false,
        sort: true,
        customHeadLabelRender: (columnMeta) => (
          <span className={classes.tblHead}>レビューOK撮影数</span>
        ),
        customBodyRender: (value) => {
          return <div className={classes.tblDataCenter}>{value}</div>;
        },
      },
    },
    {
      name: "達成率(%)",
      options: {
        filter: false,
        sort: true,
        customHeadLabelRender: (columnMeta) => (
          <span className={classes.tblHead}>達成率(%)</span>
        ),
        customBodyRender: (value) => {
          return <div className={classes.tblDataCenter}>{value}</div>;
        },
      },
    },
    {
      name: "撮影者数",
      options: {
        filter: false,
        sort: true,
        customHeadLabelRender: (columnMeta) => (
          <span className={classes.tblHead}>撮影者数</span>
        ),
        customBodyRender: (value) => {
          return <div className={classes.tblDataCenter}>{value}</div>;
        },
      },
    },
  ];
  const options = {
    selectableRows: "none",
    filterType: "checkbox",
    filter: true,
    pagination: true,
    search: true,
    print: false,
    download: true,
    viewColumns: false,
    downloadOptions: {
      filename: "エリア別撮影達成率データ.csv",
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
    },
    rowsPerPage: 100,
    textLabels: {
      body: {
        noMatch: loading ? "データ取得中です。" : "データがありません。",
        toolTip: "",
      },
      toolbar: {
        search: "検索",
        viewColumns: "列の表示",
        downloadCsv: "CSVダウンロード",
        filterTable: "テーブルのフィルター",
      },
      viewColumns: {
        title: "表示する列",
        titleAria: "テーブルの列の表示/非表示",
      },
      pagination: {
        next: "次のページ",
        previous: "前のページ",
        rowsPerPage: "表示件数",
      },
      filter: {
        all: "全て",
        title: "フィルター",
        reset: "リセット",
      },
      selectedRows: {
        text: "レコードを選択",
        delete: "削除",
        deleteAria: "選択したレコードを削除する",
      },
    },
    rowsPerPageOptions: [100, 200, 300],
    responsive: "standard",
  };

  return (
    <Grid container spacing={1}>
      <Grid item sm={12}>
        <MUIDataTable
          title={<span className={classes.customTitle}>エリア別一覧</span>}
          data={data === null ? [] : data}
          columns={columns}
          options={options}
        />
      </Grid>
    </Grid>
  );
};

ByAreaDetailTable.propTypes = {
  classes: PropTypes.object,
  selectedAreaLayerId: PropTypes.string,
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  //setCurrentModule: (param) => dispatch(setCurrentModule(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(ByAreaDetailTable));
